import { useMemo } from 'react';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import { format } from 'date-fns';
import Modal from '@/trio-ui/Modal';
import * as Styles from './AudioRecorder.styles';

type AudioRecorderComponentProps = {
  recordingTime: number;
  isRecording: boolean;
  microphoneWithoutPermission: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onConfirmMicrophoneAlert: () => void;
};

const UNIT_IN_MILLISECONDS = 1000;

export default function AudioRecorderComponent({
  recordingTime,
  isRecording,
  onStartRecording,
  onStopRecording,
  onConfirmMicrophoneAlert,
  microphoneWithoutPermission,
}: AudioRecorderComponentProps): JSX.Element {
  const formattedRecordingTime = format(recordingTime * UNIT_IN_MILLISECONDS, 'mm:ss');

  const data = useMemo(
    () => ({
      action: isRecording ? onStopRecording : onStartRecording,
      icon: isRecording ? <StopIcon /> : <MicIcon />,
      info: isRecording ? formattedRecordingTime : 'Click here to start recording your answer',
    }),
    [formattedRecordingTime, isRecording, onStartRecording, onStopRecording]
  );

  return (
    <>
      <Styles.Box onClick={data.action}>
        <Styles.Button>{data.icon}</Styles.Button>
        <Styles.Info>{data.info}</Styles.Info>
      </Styles.Box>
      <Modal
        modalId="interview-mic-modal"
        headerIcon={MicIcon}
        isCentered
        size="sm"
        hideCancelButton
        modalTitle="Oops... We can't hear you"
        bodyRender={<p>Allow app to use your microphone.</p>}
        isOpen={microphoneWithoutPermission}
        onConfirmLabel="Ok"
        onConfirmClick={onConfirmMicrophoneAlert}
        onClose={onConfirmMicrophoneAlert}
      />
    </>
  );
}
